import React, { useEffect } from 'react';
import TextInput from './fields/TextInput';
import SubmitButton from './fields/SubmitButton';
import { Divider } from '@mui/material';
import SelectInput from './fields/SelectInput';
import { useFormApi, useFormState } from 'informed';

export default function CapitalEntryForm({ loading, capitalId }) {
  const formState = useFormState();
  const formApi = useFormApi();

    useEffect(() => {
      if (['loan', 'collect', 'deposit'].includes(formState.values.type)) {
        formApi.setValue('quantity', "+");
      }
      if (['repay', 'advance'].includes(formState.values.type)) {
        formApi.setValue('quantity', "-");
      }
  }, [formState.values.type]);

  const typeOptions = React.useMemo(() => {
    const result = [
      { value: 'loan', label: 'Loan (shop<-customer)' }, // Shop receives money from customer
      { value: 'repay', label: 'Repay (shop->customer)' }, // Shop repays money to customer
      { value: 'advance', label: 'Advance (shop->customer)' }, // Shop gives money to customer
      { value: 'collect', label: 'Collect (shop<-customer)' }, // Shop collects money from customer
      { value: 'deposit', label: 'Deposit (shop+)' }, // Shop deposits money into the capital
      { value: 'withdraw', label: 'Withdraw (shop-)' }, // Shop withdraws money from the capital
    ];
    return result;
  }, []);

  return (
    <>
      <TextInput disabled field="capital_id" label="Capital ID" initialValue={capitalId} />
      <SelectInput  field="type" label="Type" options={typeOptions} />
      <TextInput field="quantity" label="Quantity" />
      <TextInput field="note" label="Note" />
      <Divider />
      <SubmitButton loading={loading}>Submit</SubmitButton>
    </>
  );
}
